import { createFileRoute } from '@tanstack/react-router'
import { TasksPage } from '@features/admin/tasks'

export const Route = createFileRoute('/admin/tasks')({
  component: RouteComponent,
})

function RouteComponent() {
  return <TasksPage />
}
